/**
 * This component is a resolver. It is meant to be used by page templates using
 * data from a CMS.
 *
 * You can send the data you receive from the CMS to the props of this components
 * by spreading them (like <Hero {...cmsData} />)
 * and then make these props fit the final module.
 */
import React from "react"
import { Hero as HeroModule } from "@bw/modules"
import { CmsImage, Button, File } from "@bw/bits"
import getButtonProps from "../../../utils/getButtonProps"
import { getSeasonVideo } from "../../../utils/seasonVideo"
import { graphql } from "gatsby"

const Hero = ({
  title,
  suptitle,
  subtitle,
  buttons,
  image,
  shortVideoFileUrl,
  longVideoUrl,
}) => {
  return (
    <HeroModule
      heroSuptitle={suptitle}
      heroTitle={title}
      excerpt={subtitle}
      video={shortVideoFileUrl || getSeasonVideo()}
      videoPopup={longVideoUrl}
      image={<CmsImage src={image} alt={image.alt} />}
      focus={image.has_focus ? image.focus_css : undefined}
      buttons={buttons.slice(0, 1).map((button, i) => {
        const props = getButtonProps(button)
        return props ? <Button {...props} key={i} /> : null
      })}
      links={buttons.slice(1).map((button, i) => {
        const props = getButtonProps(button)
        return props ? <File {...props} key={i} /> : null
      })}
    />
  )
}

/**
 * This generates a GraphQL Fragment that can be used in a page query:
 *
 * Example:
 * ... on HeroModule {
 *   ...HeroModuleFragment
 * }
 *
 * This is also what you will get in the props of your LogoGrid
 * resolver component.
 */
export const query = graphql`
  fragment HeroModuleFragment on HeroModule {
    buttons {
      isExternal
      linkType {
        value
      }
      linkText
      url
      entry {
        url
      }
    }
    image {
      alt
      has_focus
      focus_css
      localImage {
        childImageSharp {
          gatsbyImageData(width: 1800, quality: 80)
        }
      }
    }

    shortVideoFileUrl
    longVideoUrl
  }
`

export { Hero }